import React, { useEffect, useState } from "react";
import { useRecaptcha } from "../../utils/useRecaptcha";

const RecaptchaLoginWrapper = ({ children, onLogin }) => {
  const { loadRecaptchaScript, cleanupRecaptcha } = useRecaptcha();
  const [isRecaptchaLoaded, setIsRecaptchaLoaded] = useState(false);

  useEffect(() => {
    const initRecaptcha = async () => {
      try {
        await loadRecaptchaScript();

        // Esperar un poco más para asegurar que esté completamente listo
        setTimeout(() => {
          setIsRecaptchaLoaded(true);
        }, 1000);
      } catch (error) {
        console.error("Error al inicializar reCAPTCHA:", error);
        setIsRecaptchaLoaded(true);
      }
    };

    initRecaptcha();

    return () => {
      cleanupRecaptcha();
    };
  }, [loadRecaptchaScript, cleanupRecaptcha]);

  return <>{children}</>;
};

export default RecaptchaLoginWrapper;
